export default __webpack_public_path__ + "static/media/sneaker_img2.801105cc.png";